// NOTE: this constant is also imported in V2 (app/javascripts/packs/sentry.js)
// If you're modifying or moving it, remember to update the import there.
export const sentryIgnoreErrors = [
  "Can't find variable: _AutofillCallbackHandler",
  "Can't find variable: _pcmBridgeCallbackHandler",
  'Blocked a frame with origin "https://www.siepomaga.pl" from accessing a cross-origin frame. Protocols, domains, and ports must match.',

  // Errors from Android WebView, often originating from third-party SDKs (e.g.,
  // ads, Facebook In-App Browser). These have minimal direct user impact but
  // can be noisy.
  // - 'Java exception was raised...': Indicates an unhandled exception occurred
  //   *inside* the native Java/Kotlin code after a successful call from
  //   JavaScript.
  // - 'Java object is gone': A race condition where JavaScript tries to call a
  //   native object that has already been garbage-collected due to the Android
  //   component's lifecycle ending. This is a symptom of improper lifecycle
  //   management and can indicate a risk of memory leaks.
  // - 'Java bridge method invocation error': A generic error indicating failure
  //   during the communication call between JavaScript and native Java code via
  //   the WebView's bridge mechanism. Often specific to the hosting app's
  //   environment (like Facebook).
  'Java exception was raised during method invocation',
  'Java object is gone',
  'Java bridge method invocation error',

  // Error specific to Facebook In-App Browser on iOS (WKWebView).
  // It is caused by a race condition during page navigation ("Zombie Bridge"):
  // when the user leaves the page (navigation/back button), the native
  // message handler is destroyed, but a delayed JavaScript execution (e.g.
  // analytics or fetch interceptor) attempts to call window.postMessage.
  // The WebKit bridge is no longer available, triggering this DOMException.
  // It has no impact on UX as the page is already unloading.
  'InvalidAccessError: The object does not support the operation or argument.',

  // Based on the operating system, browser details and IP address, this
  // appears to be a bot-generated error. The "Object Not Found Matching Id"
  // error message originates from CefSharp framework:
  // https://github.com/cefsharp/CefSharp/blob/05577b7bf3933a057d42dabe0dc915676f9463a8/CefSharp/Internals/JavascriptObjectRepository.cs#L298
  // References:
  // https://trackjs.com/javascript-errors/object-not-found-matching-id-methodname-paramcount/
  // https://forum.sentry.io/t/unhandledrejection-non-error-promise-rejection-captured-with-value/14062/37
  /Non-Error promise rejection captured with value: Object Not Found Matching Id/,

  // CancelledError from request cancellation in React Query when using
  // AbortController polyfill. This error occurs when a request is cancelled
  // (e.g. on component unmount or manual cancellation) while using the
  // polyfill for older browsers that don't support AbortController natively.
  'new CancelledError(src/retryer)',

  // Error that occurs in Edge iOS when handling video volume/mute changes.
  // This appears to be related to Edge's video player implementation on iOS
  // and probably doesn't affect video playback.
  "Can't find variable: logMutedMessage",

  // Error that occur on iOS Safari when trying to communicate with browser
  // extension after tab was closed/changed. This is expected behavior when
  // user navigates away while extension communication is in progress.
  'Invalid call to runtime.sendMessage(). Tab not found.',

  // Error occurring in TikTok in-app browser. This is related to performance
  // timing access in TikTok's WebView implementation that doesn't properly
  // support window.timing API. Most probably does not affect application
  // functionality.
  "Cannot read properties of undefined (reading 'domInteractive')",

  // Error from WKWebView occurring in Facebook mobile browser on iOS. This is
  // thrown when a JavaScript message requires a response from native code, but
  // we don't use this messaging mechanism in our application. The error
  // originates from WebKit's internal handler for async postMessage.
  'WKWebView API client did not respond to this postMessage',

  // Request cancellation errors from fetch requests.
  //
  // List of the most popular browsers' request cancellation error messages:
  // https://web.archive.org/web/20230712160040/https://request-cancellation-test.vercel.app/
  //
  // Sentry errors with the `anulowane` message have also been found, suggesting
  // that `cancelled` is being translated.
  //
  // AbortError has to be included (below) to catch abort errors especially in
  // Firefox on Windows. Such error is thrown when a request is cancelled.
  'TypeError: Failed to fetch',
  'TypeError: NetworkError when attempting to fetch resource',
  'TypeError: cancelled',
  'TypeError: anulowane',
  'TypeError: Połączenie z Internetem jest chyba rozłączone',
  'TypeError: Load failed',
  'TypeError: Network request failed',

  // Filter out all abort errors because they are predictable and expected
  'AbortError:',
];
